<template>
  <div class="board">
    <div class="board-lists-container">
      <div class="d-inline-block">
        <Container
          :get-child-payload="getChildPayload"
          orientation="horizontal"
          @drag-start="onDragStart"
          @drop="onDrop({obj: board, items: lists}, $event)"
          :animation-duration="200"
          :drop-placeholder="dropPlaceholderOptions"
          drag-class="card-ghost"
          drop-class="card-ghost-drop"
          :drag-handle-selector="isMobileDevice ? '.drag-and-drop-is-disabled-for-mobile' : '.draggable-list-handle'"
        >
          <Draggable
            class="board-lists-container-item"
            v-for="list in lists"
            :key="'list_'+list.id"
          >
            <List :list="list" />
          </Draggable>
        </Container>
      </div>

      <div
        class="board-list-item-wrapper board-lists-container-item d-inline-block align-top"
        v-if="showArchive"
      >
        <CardsArchive class="cards-archive-list" :board="board" />
      </div>

      <div class="board-list-item-wrapper board-lists-container-item d-inline-block align-top">
        <div class="board-list board-add-new-list">
          <AddNewItem
            title="Добавить список"
            watermark="Название списка"
            @submit="addNewList($event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import SmoothDndHelpers from "@/common/smoothDndHelpers";

import CardsArchive from "./CardsArchive.vue";
import List from "./List.vue";
import AddNewItem from "./AddNewItem.vue";

export default {
  name: "Board",
  props: { board: { required: true } },
  components: { List, AddNewItem, CardsArchive },
  computed: {
    ...mapGetters(["isMobileDevice"]),
    ...mapState(["showArchive", "drag"]),
    lists() {
      if (!this.board || !this.board.lists) {
        return [];
      }

      return this.board.lists;
    },
    dropPlaceholderOptions() {
      return {
        className: "drop-preview",
        animationDuration: "150",
        showOnTop: true
      };
    }
  },
  data() {
    return {
      smoothDndHelpers: new SmoothDndHelpers(this.$order)
    };
  },
  methods: {
    getChildPayload(index) {
      return {
        index: index,
        obj: this.board,
        item: this.lists[index],
        items: this.lists
      };
    },
    onDragStart(event) {
      this.smoothDndHelpers.onDragStart(event);
    },
    onDrop(dest, event) {
      this.smoothDndHelpers.onDrop(dest, event);
    },
    addNewList(title) {
      if (!title) return;

      this.$store.dispatch("lists/new", { board: this.board, title: title });
    }
  },
  mounted() {
    const _this = this;
    this.smoothDndHelpers.dragStartedCallbacks.push(() => {
      _this.$store.commit("DRAG_LIST", true);
    });

    this.smoothDndHelpers.onDropGuards.push(() => {
      return !_this.drag.list;
    });

    this.smoothDndHelpers.dragEndIfNotDropCallbacks.push(() => {
      _this.$store.commit("DRAG_LIST", false);
    });

    this.smoothDndHelpers.beforeDropCallbacks.push(() => {
      _this.$store.commit("DRAG_LIST", false);
    });

    this.smoothDndHelpers.droppedCallbacks.push(payload => {
      _this.$store.dispatch("lists/move", {
        board: _this.board,
        list: payload.item,
        order: payload.order
      });
    });
  }
};
</script>
<style lang="postcss">
.board {
  padding: var(--border-padding);
  white-space: nowrap;

  .board-lists-container-item {
    white-space: normal;
    min-width: 281px;
    max-width: 281px;
    width: 281px;
    height: 500px;
  }

  .cards-archive-list {
  }

  .board-add-new-list {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
    color: var(--color-white);
    padding: 8px;
    background: rgba(0, 0, 0, 0.12);

    &:hover {
      background: rgba(0, 0, 0, 0.3);
    }
  }
}
</style>
